import { Route } from 'data/records'
import { resource, member, findSelector } from 'data/helpers/apiv3'
import { emptyPayload as payload } from 'data/helpers/emptyPayload'
import { fulfilled } from 'lib/promiseMiddlewareHelpers'

const PHOTO_ADDED = 'apiv3/route/photo_added'
const PHOTO_REMOVED = 'apiv3/route/photo_removed'
const DIRTY_UPDATE = 'apiv3/route/dirty_update' // update v3 state without a server roundtrip

const [api, actions] = resource(Route, [
  ['read', member.get('', ['privacyCode', 'includeTags', 'allEventIds', 'experienceIds', 'count'])],
  ['update', member.patch('', ['route', 'auditNotes'])],
  ['like', member.post('like')],
  ['unlike', member.post('unlike')]
])
actions.photoAdded = (routeId, photoId) => ({
  type: PHOTO_ADDED,
  payload,
  meta: { apiv3source: 'route', routeId, photoId }
})
actions.photoRemoved = (routeId, photoId) => ({
  type: PHOTO_REMOVED,
  payload,
  meta: { apiv3source: 'route', routeId, photoId }
})
actions.dirtyUpdate = (route) => ({
  type: DIRTY_UPDATE,
  payload,
  meta: { apiv3source: 'route', route }
})

const selectors = {
  ...findSelector(Route),
  routesForIds: (state, ids) => (
    ids.map(id => selectors.find(state, id)).filter(v => v)
  )
}

const reducers = {
  [fulfilled(actions.read.type)]: (state, action) => {
    const { id } = action.meta
    const payloadClub = action.payload.extras.find(e => e.type === 'club' && e.club.user_id === action.payload.route.user_id)
    const nextState = state.setIn(['id', id, 'club'], payloadClub?.club)
    return nextState
  },
  [PHOTO_ADDED]: (state, action) => {
    const { routeId, photoId } = action.meta
    const route = state.getIn(['id', routeId], null)
    if (!route) return state
    return state.setIn(['id', routeId, 'photoIds'], route.photoIds.concat([photoId]))
  },
  [PHOTO_REMOVED]: (state, action) => {
    const { routeId, photoId } = action.meta
    const route = state.getIn(['id', routeId], null)
    if (!route) return state
    return state.setIn(['id', routeId, 'photoIds'], route.photoIds.filter(pid => pid !== photoId))
  },
  [DIRTY_UPDATE]: (state, action) => {
    const { route } = action.meta
    return state.setIn(['id', route.id], route)
  }
}

const initialState = {}

export {
  api as routeApi,
  actions as routeActions,
  selectors as routeSelectors,
  reducers as routeReducers,
  initialState as routeInitialState
}
